import React, {Component} from 'react'
import Link from 'gatsby-link'
import NaviModal from './nav-modal'
import NavIcon from './icons/nav-icon'
import HeaderContent from './header-content';

// MEDIA
import logo from '../images/logov2_dark.svg'

// STYLES
import './header.styl'

class Header extends Component {
  constructor(props) {
    super(props);
    console.log(props)
  }

  componentDidMount () {
        const script = document.createElement("script");

        script.type = 'application/ld+json';
        script.innerHTML = 
        `
          {
            "@context": "http://schema.org",
            "@type": "Organization",
            "url": "http://www.remagencia.com/",
            "logo": "http://aremlab.com/img/logo_red.png",
            "contactPoint": [{
              "@type": "ContactPoint",
              "telephone": "+57-302-257-0914",
              "contactType": "customer service"
            }]
          }
        `;
        script.async = true;

        document.body.appendChild(script);
  }

  state = {
    navigator: false
  };

  openNavigator = (e) => {
    this.setState({
      navigator: !this.state.navigator
    })
  }

  render() {
    const locationPath = this.props.location.pathname
    return (
      <div className="HeaderWrapper" >
        <div className="HeaderContainer" >
          <Link
              className="logo"
              to="/"
              style={{
                color: 'white',
                textDecoration: 'none',
              }} >
              <img src={logo} onClick={this.handleClickHome} alt=""/>
          </Link>
            <NavIcon 
              className="NavIcon" 
              size={27} 
              color="#DF1F38" 
              navigator={this.state.navigator}
              handleClick={this.openNavigator}/>
            {
              this.state.navigator &&
                <NaviModal
                  className="NaviModal"
                  handleClick={this.openNavigator}
                />    
            }
        </div>
        
        {
          this.props.headerData.map( (item) => {
              if (locationPath === '/' + item.path + '/') {
                return <HeaderContent {...item} key={item.id} />
              } else if (locationPath === item.path) {
                return <HeaderContent {...item} key={item.id} />
              }
          })
        }
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js